import { FormControl, InputLabel } from '@material-ui/core';
import React from 'react';

import { currencyFormat } from 'utils/currencyFormat';
import Budget from 'entities/budget/model';

export const BudgetLimitPerUser = ({ budget }: { budget: Budget }): JSX.Element => (
  <>
    <FormControl style={{ width: '100%', height: 17 }}>
      <InputLabel shrink>Limit Per User</InputLabel>
    </FormControl>
    <div>
      {budget.get('limitPerUser')
        ? currencyFormat(budget.get('limitPerUser'), budget.get('currencyCode'))
        : '-'}{' '}
      (general)
      <br />
      {budget.get('capGroups').map((capGroup) => (
        <div key={capGroup.get('title')}>
          {currencyFormat(capGroup.get('limitPerUser'), budget.get('currencyCode'))} (
          {capGroup.get('title')})
        </div>
      ))}
    </div>
  </>
);
